export default __webpack_public_path__ + "static/media/warmmetabolismdrink@2x.bb62cc4d.jpg";